import * as React from 'react'

// One nesting level = the parent's 16px chevron + its 8px gap, so a nested band's chevron
// starts under the parent's icon / label.
export const GROUP_INDENT_STEP_PX = 24

interface IGroupIndentProps {
  depth: number
  stepPx?: number
}

// Depth spacer; renders nothing at depth <= 0.
export default function GroupIndent({
  depth,
  stepPx = GROUP_INDENT_STEP_PX,
}: IGroupIndentProps): React.ReactElement | null {
  if (depth <= 0) return null
  return (
    <span
      aria-hidden="true"
      className="tw:shrink-0"
      style={{ width: depth * stepPx }}
    />
  )
}
